<template>
  <div v-if="object">
    <div class="row text-white" style="background: #44927b">
      <div class="col-md-11" style="text-align: left">
        <i class="tim-icons icon-simple-remove" v-on:click="toView" style="margin-right: 10px"></i>
        <b v-if="!warning && object.date">{{convertDate(object.date) + ' : ' + fieldView(object.executorData ? object.executorData.name : "") + ' -> ' + fieldView(object.client.name)}}</b>
        <b v-else-if="!warning && object.projectDate">{{ `Плановый звонок ${convertDate(object.projectDate)} ` +  fieldView(object.executorData ? object.executorData.name : "-") + ' -> ' + fieldView(object.client.name)}}</b>
        <b v-else-if="!warning" >{{'Звонок ' + fieldView(object.executorData ? object.executorData.name : "") + ' -> ' + fieldView(object.client.name)}}</b>
        <b v-if="warning" style="color: #d9ff00"> {{ warning }}</b>
      </div>
      <div class="col-md-1" style="text-align: right">
        <i v-if="!inSave" class="tim-icons icon-check-2" v-on:click="save" style="margin-right: 10px"></i>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <textarea rows="4" cols="10"
                  class="form-control"
                  placeholder="Комментарии и заметки к беседе"
                  v-model="object.note">
        </textarea>
      </div>
    </div>
    <div class="row">
      <div v-if="object.id && object.id > 0" class="col-md-4">
        <base-input label="Дата следующего звонка"
                    v-model="object.nextDate"
                    :value="object.nextDate"
                    :date="true"
        ></base-input>
      </div>
      <div v-else class="col-md-4">
        <base-input label="Плановая дата звонка"
                    v-model="object.projectDate"
                    :value="object.projectDate"
                    :date="true"
        ></base-input>
      </div>
      <div class="col-md-4">
      </div>
    </div>
    <div v-if="!object.date" class="row">
      <div class="col-md-12">
        <table>
          <tr>
            <td  style="padding: 0; margin: 0">
              <base-checkbox v-model="object.callIsDone">    </base-checkbox>
            </td>
            <td style="padding: 0; margin: 0">
              Звонок выполнен
            </td>
          </tr>
        </table>
      </div>
    </div>


  </div>
</template>
<script>

 import BaseInput from "@/components/Inputs/BaseInput";
 import {longAsStringDate} from "@/services/utils";

 export default {
   components: {
     BaseInput,
   },
   props:{
     item: {},
     index: null,
     type: null
   },
   data() {
     return {
       socket: null,
       object: null,
       inSave: false,
       warning: null
     }
   },
   methods: {
     convertDate(time) {
       return time ? longAsStringDate(time) : "-";
     },
     fieldView(data) {
       return data ? data : '-';
     },
     toView() {
       this.$emit('toView');
     },
     async save() {
      if (!this.object.note || this.object.note.length < 2) {
        this.warning = 'Заполните комментарий к звонку' + this.object.note.length;
      } else if ((!this.object.id || this.object.id === 0) && (!this.object.projectDate && !this.object.callIsDone)) {
        this.warning = 'Звонок должен быть выполнен или иметь плановую дату';
      } else {
        this.inSave = true;
        try {
          let renewed = await this.$repo.save(this.object, this.type);
          if (renewed) {
            this.item.object = renewed;
            this.item.id = renewed.id;
            this.object = JSON.parse(JSON.stringify(renewed));
            this.inSave = false;
            this.toView();
          }
        } catch(error) {
          this.inSave = false;
        }
      }
     }
   },
   mounted() {
     this.object = JSON.parse((JSON.stringify(this.item.object)));
   }
 }
</script>
